/** OpenAI-internal usage marker emitted for Codex/Responses web-search runs. */
export const OPENAI_WEBRUN_MODEL = 'webrun';
export const OPENAI_WEBRUN_IMAGE_MODEL = 'webrun_image';

/** Costs API line item and synthetic model row used for allocated tool charges. */
export const OPENAI_WEB_SEARCH_LINE_ITEM = 'web search tool calls';
export const OPENAI_WEB_SEARCH_COST_MODEL = 'OpenAI Web Search';

/** Public standard price: USD 10 per 1,000 search actions. */
export const OPENAI_WEB_SEARCH_COST_PER_CALL = 10 / 1_000;

export const isOpenAiWebRunUsage = (model: string, usageType: string): boolean => (
  usageType === 'completions'
  && [OPENAI_WEBRUN_MODEL, OPENAI_WEBRUN_IMAGE_MODEL].includes(model.trim().toLowerCase())
);

export const isOpenAiWebSearchLineItem = (lineItem: unknown): boolean => (
  typeof lineItem === 'string'
  && lineItem.trim().toLowerCase() === OPENAI_WEB_SEARCH_LINE_ITEM
);
